import { LatLongDirection } from '../enums';
export const getLatitudeLongitude = () => {
    const location = window.navigator && window.navigator.geolocation;
    const locationCoordinates = new Promise((resolve, reject) => {
        location &&
            location.getCurrentPosition(({ coords: { latitude, longitude } }) => {
                resolve({
                    latitude,
                    longitude,
                    latitudeRef: latitude >= 0 ? LatLongDirection.NORTH : LatLongDirection.SOUTH,
                    longitudeRef: longitude >= 0 ? LatLongDirection.EAST : LatLongDirection.WEST,
                    // For EXIF, we need absolute values when storing with ref
                    absoluteLatitude: Math.abs(latitude),
                    absoluteLongitude: Math.abs(longitude)
                });
            }, error => {
                reject(error);
            });
    });
    return locationCoordinates;
};
//# sourceMappingURL=Geolocation.js.map